import { useMutation } from "@tanstack/react-query";
import { createPublicRecordFromDraft } from "@/lib/services/publicRecordService";
import type { BookingDraft } from "../bookingDraft";

export function useCreatePublicRecord() {
  return useMutation({
    mutationKey: ["publicRecord", "create"],
    mutationFn: (draft: BookingDraft) => createPublicRecordFromDraft(draft),
  });
}
